import React from 'react';
import { ScheduledMaintenance } from '../components/ScheduledMaintenance';
export function Maintenance() {
  return <ScheduledMaintenance data-id="element-648" data-mp="133o4d6zqbk6h" />;
}